import type { ProgramTimelineContentObject } from 'models';
import type { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Avatar, Flex, Text } from 'ui';
import { images } from 'common/utils';
import { IconDirectMessageButton } from 'features/chat';

const TEXT_PREVIEW_LENGTH = 100;

const getTitleAndType = (item: ProgramTimelineContentObject): { title?: string; type: ReactNode } => {
  switch (item.type) {
    case 'activity':
      return { title: item.activity.name, type: item.type };

    case 'event':
      return { title: item.event.name, type: item.type };

    case 'poll':
      return { title: item.poll.title, type: item.type };

    case 'post':
      return { title: item.post.title ?? item.post.textContent, type: item.type };

    case 'withings_order_post':
      return {
        title: item.withings_order_post.title ?? item.withings_order_post.textContent,
        type: <Trans>Withings order</Trans>,
      };
  }
};

type P = {
  item: ProgramTimelineContentObject;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const TextPreview = ({ item }: P) => {
  const { t } = useTranslation();
  const { title, type } = getTitleAndType(item);
  const displayTitle =
    title && item.type !== 'event' && title.length > TEXT_PREVIEW_LENGTH
      ? `${title.slice(0, TEXT_PREVIEW_LENGTH)}...`
      : title;
  const { author, publishAt } = item;

  return (
    <Flex className="topic-item__text-preview" vertical>
      <Text className="topic-item__text-preview__title">{displayTitle}</Text>
      <Text className="topic-item__text-preview__date" size="small">
        {t('dateFormats.dateTime', { date: publishAt })} • {type}
      </Text>
      <Flex align="center" gap="xs">
        <Avatar fallbackPhoto={images.default.programCoverPhoto} size="sm" src={author.profilePhoto}>
          {author.firstName.slice(0, 2).toUpperCase()}
        </Avatar>
        <Text size="small">
          <Text size="small">Posted by</Text> {`${author.firstName} ${author.lastName}`}
        </Text>
        <IconDirectMessageButton legacyUserId={author.id} small type="text" />
      </Flex>
    </Flex>
  );
};

export default TextPreview;
